// extracted by mini-css-extract-plugin
export var chevron = "_ib-2";
export var dropdownItems = "_ib-0";
export var item = "_ib-1";